export const resources = {
  resourcesFolderInfoText: 'Plik',
  resourcesItemInfoLastUpdText: 'Ostatnia aktualizacja',
  resourcesItemInfoUploadedText: 'Wgrano',
  resourcesSearchInputText: 'Szukaj',
  resourcesUserActionSheetOptionTitle: 'Skopiuj link',
  resourcesActionCopiedAlertText: 'Link skopiowany!',
  resourcesOwnersCurtainEditOptionText: 'Edytuj tytuł',
  resourcesOwnersCurtainDeleteOptionText: 'Usuń',
  resourcesOwnerCurtainHideOptionText: 'Ukryj (Nieaktywny)',
  resourcesEditPopupTitle: 'Edytuj tytuł',
  resourcesEditPopupResetButtonTitle: 'Resetuj',
  resourcesEditPopupApplyButtonTitle: 'Zastosuj',
  resourcesItemEditedAlertText: 'Element został pomyślnie zaktualizowany!',
  resourcesHidePopupTitle: 'Ukryj',
  resourcesHidePopupText: 'Czy ukryć ten element?',
  resourcesHidePopupCancelButtonTitle: 'Anuluj',
  resourcesHidePopupConfirmButtonTitle: 'Potwierdź',
  resourcesDeletePopupTitle: 'Usuń',
  resourcesDeletePopupText: 'Czy usunąć ten element?',
  resourcesDeletePopupCancelButtonTitle: 'Anuluj',
  resourcesDeletePopupConfirmButtonTitle: 'Potwierdź',
  resourcesItemDeletedAlertText: 'Element został pomyślnie usunięty!',
  resourceDetailsLinkText: 'To zewnętrzny adres URL i zostanie otwarty w nowym oknie. Otworzyć?',
  resourceDetailsLinkOpenButtonTitle: 'Otwórz',
  resourceDetailsLinkOpenAgainButtonTitle: 'Otwórz ponownie',
  resourceDetailsLinkCopyURLButtonTitle: 'Skopiuj adres URL docelowy',
  resourceDetailsLinkCopiedURLAlertText: 'Adres URL skopiowany!',
  resurceDetailsLinkCurtainOptionCopyText: 'Skopiuj link',
  resourceDetailsFileInfoLastUpdText: 'Ostatnia aktualizacja',
  resourceDetailsFileInfoUploadText: 'Wgrano',
  resourceDetailsFileSaveButtonTitle: 'Otwórz',
  resourceDetailsFileCopyButtonTitle: 'Skopiuj link',
  resourcesOwnersCurtainCopyOptionText: 'Skopiuj link',
  resourceDetailsFileLoadingText: 'Ładowanie...',
  resourceDetailsImageCurtainCopyOptionText: 'Skopiuj link',
  resourceDetailsImageCurtainDownloadOptionText: 'Pobierz',
  resourceFolder: 'Folder',
  resourceAdded: 'Dodano'
}
